<template>
    <div v-if="errors" class="errors">
        <div class="error" v-for="errorJoueur in errors">
           <s-button
                label=""
                :icon="typeError(errorJoueur.type)"
                theme="is-small is-black"
                @onclick="modalOpen(errorJoueur)"
            />
        </div>
     
        
    </div>
</template>
<style scoped>
    .errors {
        margin-left:-30px;
        width: 230px;
    }
    .error {
        display: inline-block;
        margin-left: 2px;
    }
</style>
<script>
export default {
    props: ["errors"],
   
  
    methods: {
        modalOpen(errorDetail) {
            this.$emit("openModalJoueur", errorDetail);
        },
        typeError(type) {
            switch (type) {
                case 1:
                    return "exchange-alt"
                    break;
                case 2:
                    return "user-friends"
                    break;
                case 3:
                    return "list-ol"
                    break;
                case 4:
                    return "people-arrows"
                    break;
                case 5:
                    return "stream"
                    break;
                case 6:
                    return "street-view"
                    break;
                default:
                    break;
            }
        },
    }
}
</script>